import { jsx as l, jsxs as m } from "react/jsx-runtime";
import { FocusTrapFeatures as C, FocusTrap as A } from "@headlessui/react";
import { ColorPicker as f, Tooltip as E, NeutralButton as I, NeutralTypeEnum as w, PrimaryButton as L } from "@systemeio/ui";
import { useEditorState as O } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as P } from "react";
import { useTranslation as k } from "../../i18n.mjs";
import { twMerge as h } from "tailwind-merge";
import { DEFAULT_COLOR as F, getToolbarIconClassName as T, TOOLBAR_BUTTON_CLASSNAMES as b, getToolbarCaptionClassName as S, TOOLTIP_STYLES as _ } from "../../constants/default-styles.mjs";
import g from "../../icons/palette-icon.mjs";
import { normalizeToHex as B } from "@systemeio/util";
import { isImageSelected as R } from "../image-extension/utils/is-image-selected.mjs";
const V = (s, x) => {
  const { t } = k(), { shouldHideTooltip: p, showAlpha: i = !0 } = x ?? {}, e = O({
    editor: s,
    selector: ({ editor: o }) => ({
      isEditable: (o == null ? void 0 : o.options.editable) ?? !1,
      textColor: o == null ? void 0 : o.getAttributes("textStyle").color,
      isImageSelected: R(o)
    })
  }), u = e == null ? void 0 : e.textColor, n = u ? B(u) : F, c = !!u, a = !(e != null && e.isEditable) || !!(e != null && e.isImageSelected);
  return P(() => {
    const o = (r) => {
      if (!s) return null;
      s.chain().setColor(r).run();
    }, N = (r) => {
      if (!s) return null;
      const y = r() ?? n;
      s.chain().focus().setColor(y).run();
    }, v = () => {
      if (!s) return null;
      s.chain().focus().unsetColor().run();
    }, d = (r) => /* @__PURE__ */ l(A, { features: C.None, children: /* @__PURE__ */ m("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ l(
        I,
        {
          className: "w-full",
          neutralType: w.danger,
          disabled: !c,
          onClick: v,
          children: t("global.clear")
        }
      ),
      /* @__PURE__ */ l(
        L,
        {
          className: "w-full",
          onClick: () => N(r),
          children: t("global.apply")
        }
      )
    ] }) });
    return {
      toolbarRender: /* @__PURE__ */ l(
        f,
        {
          color: n,
          onChange: o,
          additionalPopoverChildren: (r) => d(r),
          disabled: a,
          showAlpha: i,
          children: () => /* @__PURE__ */ l(
            E,
            {
              disabled: p || a,
              label: t("font_color"),
              ..._,
              children: /* @__PURE__ */ m(
                "div",
                {
                  className: h(
                    b,
                    "main-transition-colors gap-1.5",
                    "relative"
                  ),
                  children: [
                    /* @__PURE__ */ l(g, { className: T(a) }),
                    c && /* @__PURE__ */ l(
                      "div",
                      {
                        className: "absolute bottom-0 h-1 w-4 rounded-lg",
                        style: { backgroundColor: n }
                      }
                    )
                  ]
                }
              )
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ l(
        f,
        {
          focusTrapFeatures: C.FocusLock,
          color: n,
          onChange: o,
          additionalPopoverChildren: (r) => d(r),
          disabled: a,
          showAlpha: i,
          children: () => /* @__PURE__ */ m(
            "div",
            {
              className: h(
                b,
                "gap-1.5",
                "relative",
                "flex gap-1",
                S(a)
              ),
              children: [
                /* @__PURE__ */ l(g, { className: T(a) }),
                t("font_color"),
                c && /* @__PURE__ */ l(
                  "div",
                  {
                    className: "absolute right-0 h-1.5 w-1.5 rounded-full",
                    style: { backgroundColor: n }
                  }
                )
              ]
            }
          )
        }
      )
    };
  }, [n, s, c, a, p, i, t]);
};
export {
  V as useTextColorExtensionToolbar
};
